export * from "@punchup/ui-common/components/policiesfooter";
